module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipAppointment"
  }, [_c('h2', [_vm._v("VIP开放日活动")]), _vm._v(" "), _c('p', {
    staticClass: "border",
    staticStyle: {
      "text-indent": "2rem"
    }
  }, [_vm._v("VIP开放日发放免费名额看诊专家号，深度了解VIP，感受VIP的服务。互动全程不低于30分钟，免挂号费，活动后如果您办理VIP，您还可享受VIP服务期限延长。"), _c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/vipAppointmentDetila'
        })
      }
    }
  }, [_vm._v("点击查看更多>>>")])]), _vm._v(" "), _c('h3', [_vm._v("参与人群")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("1、仅限需要辅助生殖助孕的患者（IVF、IUI、FET）。")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("2、仅限女方卡号申请，一个卡号只有一次申请机会。")]), _vm._v(" "), _c('h3', [_vm._v("活动时间")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("每周一、四、六：14:20-14:50   15:20:-15:50  16:20-16:50（活动长期有效）。")]), _vm._v(" "), _c('h3', [_vm._v("活动院区")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("西囡院区VIP。")]), _vm._v(" "), _c('h3', [_vm._v("参与方式")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }, [_vm._v("如果您符合参与要求，只需要在下方方框内选择您合适的时间即可参与。报名后未及时参与者视为自动放弃，将无法再次申请。")]), _vm._v(" "), _c('group', [_c('popup-radio', {
    attrs: {
      "title": "预约日期",
      "options": _vm.datelist,
      "placeholder": "请选择",
      "readonly": _vm.disabledIf
    },
    on: {
      "on-hide": _vm.dateHide
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  }), _vm._v(" "), _c('popup-radio', {
    attrs: {
      "title": "预约时间段",
      "options": _vm.timelist,
      "placeholder": "请选择",
      "readonly": _vm.disabledIf
    },
    nativeOn: {
      "click": function($event) {
        _vm.timeClick($event)
      }
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disabledIf
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.submitTxt))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070c6a31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/vipnotifyProject/vipAppointment.vue
// module id = fUXy
// module chunks = 6